<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import LoadingScreen from "@/components/inner-components/LoadingScreen";

export default {
  name: "App",
  data() {
    return {
      isScrolling: "",
    };
  },
  head: {
    // Meta tags
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1.0" },
      {
        name: "description",
        content:
          "Intervi combines marketing and advertising services. This allows us to create a comprehensive strategy for your brand.",
        id: "desc",
      }, // id to replace intead of create element
      // ...
      // Twitter
      //{ n: 'twitter:description', c: 'Content description less than 200 characters'},
      // ...
      // Facebook / Open Graph
      //{ property: 'fb:app_id', content: '123456789' },
      //{ property: 'og:title', content: 'Content Title' },
      // with shorthand
      // ...
      // Google+ / Schema.org
      //{ itemprop: 'name', content: 'Content Title' },
      //{ itemprop: 'description', content: 'Content Title' },
      // ...
      // OG:image
      { p: "og:image", c: "/static/fb_intervi_post.png" },
      { p: "og:image:type", c: "image/png" },
      { p: "og:image:width", c: "1200" },
      { p: "og:image:height", c: "630" },
      { name: "p:domain_verify", content: "e8f96b64d33b65bad082c8d4c6446465" },
    ],
    link: [{ rel: "icon", href: "/static/favicon.png", type: "image/png" }],
    script: [
      {
        async: true,
        src: "https://unpkg.com/lazysizes@5.0.0-beta2/lazysizes.min.js",
      },
    ],
  },
  watch: {
    isScrolling: function () {
      if (this.isScrolling == true) {
        console.log("scolling off");
      } else {
        console.log("scrolling on");
      }
    },
  },

  components: {
    LoadingScreen,
  },
};
</script>

<style lang="scss">
@import "./scss/main";
</style>


// WEBPACK FOOTER //
// src/App.vue